import { render, staticRenderFns } from "./TrainerWildFightWinNext.vue?vue&type=template&id=51260728&scoped=true"
import script from "./TrainerWildFightWinNext.vue?vue&type=script&lang=js"
export * from "./TrainerWildFightWinNext.vue?vue&type=script&lang=js"
import style0 from "./TrainerWildFightWinNext.vue?vue&type=style&index=0&id=51260728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51260728",
  null
  
)

export default component.exports